var _mask, _path, _mask2, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAbout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 25,
    viewBox: "0 0 11 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1584_3668",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 0H0V1L1.83333 2L2.75 5H6.41667L7.33333 2L9.16667 1H10.5C10.7761 1 11 0.776142 11 0.5C11 0.223858 10.7761 0 10.5 0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V-1.5H-1.5V0H0ZM0 1H-1.5V1.89045L-0.718278 2.31684L0 1ZM1.83333 2L3.26786 1.56167L3.08899 0.976271L2.55161 0.683157L1.83333 2ZM2.75 5L1.31547 5.43833L1.63987 6.5H2.75V5ZM6.41667 5V6.5H7.52679L7.85119 5.43833L6.41667 5ZM7.33333 2L6.61506 0.683157L6.07768 0.976271L5.89881 1.56167L7.33333 2ZM9.16667 1V-0.5H8.78418L8.44839 -0.316843L9.16667 1ZM0 1.5H10.5V-1.5H0V1.5ZM1.5 1V0H-1.5V1H1.5ZM2.55161 0.683157L0.718278 -0.316843L-0.718278 2.31684L1.11506 3.31684L2.55161 0.683157ZM4.18453 4.56167L3.26786 1.56167L0.398806 2.43833L1.31547 5.43833L4.18453 4.56167ZM6.41667 3.5H2.75V6.5H6.41667V3.5ZM5.89881 1.56167L4.98214 4.56167L7.85119 5.43833L8.76786 2.43833L5.89881 1.56167ZM8.44839 -0.316843L6.61506 0.683157L8.05161 3.31684L9.88494 2.31684L8.44839 -0.316843ZM10.5 -0.5H9.16667V2.5H10.5V-0.5ZM9.5 0.5C9.5 -0.0522852 9.94772 -0.5 10.5 -0.5V2.5C11.6046 2.5 12.5 1.60457 12.5 0.5H9.5ZM10.5 1.5C9.94772 1.5 9.5 1.05229 9.5 0.5H12.5C12.5 -0.60457 11.6046 -1.5 10.5 -1.5V1.5Z",
    fill: "#797979",
    mask: "url(#path-1-inside-1_1584_3668)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_1584_3668",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.916667 4H8.25V8L9.16667 11V25H0V11L0.916667 8V4Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 4H9.75V2.5H8.25V4ZM0.916667 4V2.5H-0.583333V4H0.916667ZM8.25 8H6.75V8.22405L6.81547 8.43833L8.25 8ZM9.16667 11H10.6667V10.7759L10.6012 10.5617L9.16667 11ZM9.16667 25V26.5H10.6667V25H9.16667ZM0 25H-1.5V26.5H0V25ZM0 11L-1.43453 10.5617L-1.5 10.7759V11H0ZM0.916667 8L2.35119 8.43833L2.41667 8.22405V8H0.916667ZM8.25 2.5H0.916667V5.5H8.25V2.5ZM9.75 8V4H6.75V8H9.75ZM10.6012 10.5617L9.68453 7.56167L6.81547 8.43833L7.73214 11.4383L10.6012 10.5617ZM10.6667 25V11H7.66667V25H10.6667ZM0 26.5H9.16667V23.5H0V26.5ZM-1.5 11V25H1.5V11H-1.5ZM-0.517861 7.56167L-1.43453 10.5617L1.43453 11.4383L2.35119 8.43833L-0.517861 7.56167ZM-0.583333 4V8H2.41667V4H-0.583333Z",
    fill: "#797979",
    mask: "url(#path-3-inside-2_1584_3668)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/About.e3c4f88f2dba7b7ff31b04d43398bcb5.svg";
export { ForwardRef as ReactComponent };